import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Order from '../Components/Order/Order';
//import AES from 'crypto-js/aes';

function ThankYou(props) {
  const params = useParams();
  const [OrderDetails, setOrderDetails] = useState(null);
  const [IsLoading, setIsLoading] = useState(false);
  const [netError, setNetError] = useState(null);

  function getOrderDetails(orderCryptedId) {
    let params = [
      //{ name: "id_e_user", value: props.userData ? props.userData.id_e_user.toString() : "0" },
      //{ name: "id_e_order", value: orderId.toString() },
      { name: "string_code", value: orderCryptedId },
    ];
    props.wsCall(
      "https://ws.mediatoys.it/order/DettaglioOrdineCrypt",
      IsLoading,
      setIsLoading,
      netError,
      setNetError,
      params,
      (respData) => {
        if (props.cfg.debug === true) 
          console.log(respData);

        // update cart item number / status
        let params = [
          {name: "session", value: props.sessionKey},
          {name: "id_e_user", value: props.userData? props.userData.id_e_user.toString() : "0"}
        ];
        props.wsCall("https://ws.mediatoys.it/carrello/cart_detail", IsLoading, setIsLoading, netError, setNetError, params, (respData2) => {
          props.cartUpd(respData2.data); 
        });

        // handle get order detail response
        if (respData.status === "true") {
          setOrderDetails(respData);
        } else {
          console.log("Errore ordine: "+respData.message);
        }
      }
    );
  }
/*
thankyou url
https://localhost:3001/thankyou/aGlvdkFmMnRmTzBJM2ZBZDZhSUszdz09
*/

  if (OrderDetails === null && !IsLoading && params.cryptedId.length > 0) {
    /*
    const CryptoJS = require("crypto-js");

    //var Sha256 = CryptoJS.SHA256;
    var Hex = CryptoJS.enc.Hex;
    var Utf8 = CryptoJS.enc.Utf8;
    //var Base64 = CryptoJS.enc.Base64;
    var AES = CryptoJS.AES;
  
    var secret_key = props.cfg.crypt_key;
    var secret_iv  = props.cfg.crypt_iv;
  
  //  var key = Sha256(secret_key).toString(Hex).substr(0,32); // Use the first 32 bytes (see 2.)
  //  var iv = Sha256(secret_iv).toString(Hex).substr(0,16);
    var key = secret_key.toString(Hex).substr(0,32); // Use the first 32 bytes (see 2.)
    var iv = secret_iv.toString(Hex).substr(0,16);
  
    // Decryption
    //console.log("params.cryptedId: " + params.cryptedId);
    //console.log("atob(cryptedId): " + atob(params.cryptedId));
    var decryptedId = AES.decrypt(atob(params.cryptedId), Utf8.parse(key), {
                iv: Utf8.parse(iv),
                mode: CryptoJS.mode.CBC,
              }).toString(Utf8); 
    //console.log("decrypted Id: " + decryptedId); // 
    getOrderDetails(decryptedId);
    */
    if (!params.cryptedId.match(/^[0-9a-zA-z]*$/)) {
      //setNetError("Formato del numero d'ordine errato. Si prega di contattare la amministrazione.");
      setOrderDetails({status: "false", message: "Formato del numero d'ordine errato.", data: null});
    } else
      getOrderDetails(params.cryptedId);
  }

  //console.log(OrderDetails);
  if (IsLoading === true || OrderDetails === null) {
    return (
      <div className="spinner">
        <img src="/images/waiting.gif" alt="loading..." />
      </div>
    );
  }

  return (
    <>
      <div className="contenitore_01">
        <div className="contenuto_grazie">
          {netError !== null ? <p>{netError}</p> : null}
          <h1 className="titolo_pagina">Grazie per l'ordine effettuato.</h1>
          <div className="comunicazione_pagina">
            {OrderDetails.status === "true" ? (
              <p>L'ordine è stato ricevuto correttamente.</p>
            ) : (
              <>
                <p>
                  Purtroppo si è verificato un inconveniente:{" "}
                  {OrderDetails.message}
                </p>
                <p>
                  Si prega di ricaricare la pagina o contattare
                  l'amministrazione.
                </p>
              </>
            )}
          </div>

          {OrderDetails.status === "true" && OrderDetails.data !== null ? (
            <Order
              order={OrderDetails.data.ordine[0]}
              items={OrderDetails.data.ordine_prodotti}
              paymentUrls={OrderDetails.data.url_payment}
              fullMode={false}
              convert={props.cfg.convert}
            />
          ) : null}
        </div>

        <div className="clear"></div>
      </div>
    </>
  );
}

export default ThankYou;
